import { completedList } from "@/mocks/comicData";
import ComicCard from "@/components/feature/ComicCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Completed() {
  return (
    <section id="completed" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="一次追完不烂尾"
          title="完结漫画推荐"
          subtitle="收录全篇完结的高分漫画，标注完整话数。从第一话到结局一口气看完，杜绝断更烦恼。"
        />

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {completedList.map((comic) => (
            <ComicCard key={comic.id} comic={comic} badge="完结" />
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="#fansub"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
          >
            浏览更多完结佳作
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}